import styled from 'styled-components';

import { CARD_HEIGHT } from '@/components/Card/Card.constants';
import { CONTAINER_MAX } from '@/constants/breakpoints';
import { commonSkeletonStyles, flexBetween, flexColumn } from '@/styles/common';

export const CardWrapper = styled.div<{ $isMine?: boolean }>`
  background-color: var(--bg-card);
  border-radius: 28px;
  padding: 20px;
  ${flexColumn};
  gap: 16px;
  color: var(--textAndLabels-main);
  border: 1px solid var(--border-secondary);
  height: ${({ $isMine }) =>
    $isMine ? CARD_HEIGHT.profile : CARD_HEIGHT.public};

  @media (max-width: ${CONTAINER_MAX.mobileL}) {
    height: ${({ $isMine }) =>
      $isMine ? CARD_HEIGHT.profileMobile : CARD_HEIGHT.public};
  }
`;

export const CardHeader = styled.div`
  ${flexBetween};
`;

export const CompanyInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const CardBody = styled.div`
  ${flexColumn};
  gap: 10px;
  flex: 1;
`;

export const CardActions = styled.div`
  ${flexColumn};
  gap: 14px;
  margin-top: auto;
`;

export const CardFooter = styled.div`
  ${flexBetween};
`;

export const SkeletonLine = styled.div<{
  $maxWidth?: string;
  height?: number;
}>`
  max-width: ${({ $maxWidth }) => $maxWidth ?? '100%'};
  width: 100%;
  height: ${({ height }) => `${height ? height : 10}px`};
  border-radius: 28px;
  ${commonSkeletonStyles}
`;

export const PromoteButtonSkeleton = styled.div`
  width: 100%;
  height: 40px;
  border-radius: 28px;
  ${commonSkeletonStyles}
`;

export const SkeletonCircle = styled.div<{ $size: number }>`
  width: ${({ $size }) => `${$size}px`};
  height: ${({ $size }) => `${$size}px`};
  border-radius: 110px;
  flex-shrink: 0;
  ${commonSkeletonStyles}
`;
